import { Typography } from '@mui/material';

export const Screen6ConflictingPriorities = ({ selectedIndustry }) => {
  if (!selectedIndustry) return null;

  return (
    <div className="p-6">
      <Typography fontSize={35} textAlign="center">
        Conflicting Priorities
      </Typography>
      <Typography fontSize={20} textAlign="center" my={8}>
        Conflicts and their Implications:
      </Typography>

      <div className="mb-6">
        <Typography fontSize={19} fontWeight={600} textAlign="center">
          {selectedIndustry.ConflictingPriorities}
        </Typography>
        <Typography fontSize={18} mt={2}>
          {selectedIndustry.ConflictImplications}
        </Typography>
      </div>

      <div className="mb-6">
        <Typography fontSize={19} fontWeight={600} textAlign="center">
          {selectedIndustry.ConflictingPriorities2}
        </Typography>
        <Typography fontSize={18} mt={2}>
          {selectedIndustry.ConflictImplications2}
        </Typography>
      </div>
    </div>
  );
};
